define('glu/grid/body/loadingView',['require','../../itemView','../../locale','hbs!./loadingViewText.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        locale = require('../../locale'),
        tpl = require('hbs!./loadingViewText.hbs');

    return ItemView.extend({
        template: tpl,
        className: 'glu-content-loading',

        templateHelpers: function() {
            return {
                text: this.options.text || locale.get('loading')
            };
        }
    });
});

